import React from "react";
import Select from "react-select";
import clonedeep from "lodash.clonedeep";

import { IS_VALID } from "utils";

let schema = {
	"className": "Notifications",
	"classNameLabel": "Notification History",
	"limit": 10,
	"columns": [
		{
			"columnName": "objectId",
			"type": "string"
		},
		{
			"columnName": "subject",
			"type": "string"
		},
    {
      columnName: "User",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
    {
      columnName: "Sender",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
		{
			columnName: "status",
			type: "string",
			headerStyle: {
        minWidth: 132
      },
			render: ({ object}) => {
				let renderValue = "ACTIVE";

				if (IS_VALID(object.get("status"))) {
          renderValue = object.get("status");
        }

        return renderValue;
			},
			customFilter: {
				display: (value, onChange) => {
					return (
            <Select
              options={[
                {
                  label: "ACTIVE",
                  value: "ACTIVE"
                },
                {
                  label: "INACTIVE",
                  value: "INACTIVE"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
				},
				onSearch: ({ query, value }) => {
					if (IS_VALID(value.value)) {
						if (value.value === "ACTIVE") {
							let clone = clonedeep(query);

							clone.equalTo("status", value.value);

							query.doesNotExist("status");

							query = Parse.Query.or(clone, query);
						} else {
							query.equalTo("status", value.value)
						}
					}

					return query;
				}
			}
		},
    {
      columnName: "sendMode",
      columnLabel: "send mode",
      type: "string",
      headerStyle: {
        minWidth: 101,
        whiteSpace: "nowrap"
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "TEST",
                  value: "TEST"
                },
                {
                  label: "LIVE",
                  value: "LIVE"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("sendMode", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "device",
      type: "string",
      headerStyle: {
        minWidth: 133
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "ALL",
                  value: "ALL"
                },
                {
                  label: "ANDROID",
                  value: "ANDROID"
                },
                {
                  label: "IOS",
                  value: "IOS"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("device", value.value);
          }

          return query;
        }
      }
    },
		{
			"columnName": "message",
			"show": false,
			"type": "string"
		},
		{
			"columnName": "cardTypes",
			"columnLabel": "Card Type",
			"show": false,
			"type": "array"
		},
		{
			"columnName": "browser",
			"show": false,
			"type": "string"
		},
		{
			"columnName": "screen",
			"show": false,
			"type": "string"
		},
		{
			"columnName": "url",
			"show": false,
			"type": "string"
		},
		// {
		// 	"columnName": "pushTotalCount",
		// 	"columnLabel": "Push Total Count",
		// 	"type": "Number",
		// 	"show": true
		// },
		// {
		// 	"columnName": "isSendPushNow",
		// 	"columnLabel": "Send Push Now",
		// 	"type": "boolean",
		// 	"show": false
		// },
		{
			"columnName": "specificUsers",
			"type": "array",
			"show": false,
			"render":  ({ object }) => {
				let renderValue = "";

				if (typeof object.get("specificUsers") !== "undefined" && Array.isArray(object.get("specificUsers"))) {
					renderValue = object.get("specificUsers").join(", ");
				}

				return renderValue;
			}
 		},
		{
			"columnName": "blacklistedUsers",
			"type": "array",
			"show": false,
			"render":  ({ object }) => {
				let renderValue = "";

				if (typeof object.get("blacklistedUsers") !== "undefined" && Array.isArray(object.get("blacklistedUsers"))) {
					renderValue = object.get("blacklistedUsers").join(", ");
				}

				return renderValue;
			}
		},
		// {
		// 	"columnName": "isVip",
		// 	"columnLabel": "is vip",
		// 	"type": "boolean"
		// },
		{
			"columnName": "pushDateTime",
			"columnLabel": "push date",
			"type": "Date",
			format: "MMM DD, YYYY hh:mm A"
		},
		{
			"columnName": "createdAt",
			"type": "Date"
		},
		{
			"columnName": "updatedAt",
			"type": "Date"
		}
	]
};

module.exports = schema



// WEBPACK FOOTER //
// ./components/ScheduledNotification/NotificationSchema.js